/* template */
<template><div><es-popup :show="(showPopup)" align="center" @overlay-click="overlayClickHandle" class="es-custom-class"><div class="es-rm-container-code" v-if="(typeCode10602Dx)"><span class="es-conent-text">短信验证</span><span class="es-conent-text-p">{{ smsCheckNotice }}</span><mpx-view @tap="onClickMessageCode" class="es-code-button">去核验</mpx-view></div><div class="es-rm-container" v-if="(typeCode10603)"><mpx-image :style='["width: 100px; height: 100px;"] | transRpxStyle' src="https://pt-starimg.didistatic.com/static/starimg/img/DWtxBxZakm1641959558379.png" class="es-rm-image"></mpx-image><span class="es-rm-text">{{ rmText }}</span><div><mpx-view @tap="onClickFace" class="buttonStyle"><span>同意协议并人证核验</span></mpx-view></div><div v-if="(typeCode10602 && !cxvipVerify)"><mpx-view @tap="onClickMessage" class="buttonStyleNone">无法刷脸，通过短信核验</mpx-view></div><es-shake :shake="(shake)"><div class="es-rm-agree-box"><div class="es-rm-agreement"><es-checkbox-group :value="checkboxValue" mpxModelEvent="input" @mpxModel='__model("checkboxValue", $event, ["value"], undefined)' direction="row"><es-checkbox label-position="right" name="1" shap="round" :iconSize="(16)" :icon-style="({borderRadius: '4px'})"><span class="es-rm-checkbox">勾选表示已阅读并同意</span></es-checkbox></es-checkbox-group></div><mpx-view @tap="goto" hover-class="navigator-hover" class="es-rm-navigator es-rm-navigator-hover">服务协议、认证协议</mpx-view></div></es-shake></div></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0659070a"}'>
  @import '~@/mixins/stylus/color.styl'

  .es-rm-container
    width 290px
    min-height 311px
    background #E2EEFF
    background linear-gradient(to bottom, #E2EEFF, #ffffff)
    border-radius 4px
    display inline-block
  .es-rm-container-code
    width 290px
    background #ffffff
    // background linear-gradient(to bottom, #E2EEFF, #ffffff)
    border-radius 4px
    display inline-block
    padding 10px 0px
  .es-rm-image
    margin 30px auto 0px auto
    display block
  .es-rm-agree-box
    display flex
  .es-rm-text
    padding 27px 16px 0px
    display block
    font-size 15px
    line-height 21px
  .buttonStyle
    margin-top 24px
    color white
    background $train-color-theme-blue
    font-size 16px
    border-color $train-color-theme-blue
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
  .buttonStyleNone
    margin-top 24px
    color $train-color-theme-blue
    background $train-color-fff
    font-size 16px
    border 1px #1473FF solid
    padding 10px 10px
    margin 16px
    text-align center
    border-radius 8px
  .es-rm-agree-box
    padding 0px 10px 16px 10px
  .es-rm-checkbox
    font-size 13px
    color $train-color-999
    margin-left -5px
  .es-rm-navigator
    font-size 12px !important
    line-height 23px
    color $train-color-theme-blue
  .es-code-button
    color $train-color-theme-blue
    font-size 16px
    text-align center
    padding 10px 0px
    border-top 1px $train-color-eee solid
  .es-conent-text
    padding 15px 0px 10px 0px
    display block
    font-size 16px
    text-align center
  .es-conent-text-p
    padding 0px 30px 20px 30px
    display block
    font-size 14px
    color $train-color-999
  .exclamation-circle-filled
    color $train-color-theme-blue
  .es-rm-navigator
    font-size 13px !important
    line-height 20px
    display block
    color $train-color-theme-blue
    text-decoration none
  .es-rm-navigator-hover
    color #506482
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0659070a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./risk-management.mpx.js?isComponent&outputPath=components%2Frisk-management0659070a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./risk-management.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Frisk-management0659070a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0659070a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/risk-management0659070a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-shake':getComponent(require("../../../../components/transition-shake/index.mpx?isComponent&outputPath=components%2Findex13bbb724%2Findex")),'es-checkbox':getComponent(require("../../../../es-mpx-ui/lib/checkbox/index.mpx?isComponent&outputPath=components%2Findex8e1a7e44%2Findex")),'es-checkbox-group':getComponent(require("../../../../es-mpx-ui/lib/checkbox-group/index.mpx?isComponent&outputPath=components%2Findex5f7ef460%2Findex")),'es-popup':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-face':getComponent(require("../face/index.mpx?isComponent&outputPath=components%2Findexb7e13324%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
